module.exports = __webpack_public_path__ + "9178325bd8f7353ce881389d4e5743fd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/wood.png
// module id = 3378
// module chunks = 0